module.exports = __webpack_public_path__ + "static/media/power-cord.6730afa8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/power-cord.svg
// module id = 3369
// module chunks = 7